import React, { useEffect } from "react";
import "./Unauthorized.scss";
import Warning from "../../images/noto_warning.svg";
import { useLocation } from "react-router-dom";
import { getIp, recordUnauthorizedAccess } from "../../util/API/log";
import { useSelector } from "react-redux";

function Unauthorized() {
  const location = useLocation();
  const previousPage = location.state?.page;
  const userEmail = useSelector((state) => state.login.email.emailAccount);

  useEffect(() => {
    const recordLog = async () => {
      const ip = await getIp();
      const recordLogs = await recordUnauthorizedAccess(
        userEmail,
        previousPage,
        ip
      );
    };
    recordLog();
  }, []);

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container d-flex justify-content-center align-items-center">
        <div className="unauthroized-message d-flex">
          <img src={Warning} loading="lazy" />
          <div className="unauthroized-message-container">
            <p className="unauthroized-message-header">Unauthorized Access</p>

            <p className="unauthroized-message-text">
              Your account does not have access to this page. Please contact
              your system admin for any questions.
              {/* <span className="underline-link">switch</span> or{" "}
              <span className="underline-link">login</span> to your account. */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Unauthorized;
